import React, { useState } from "react";
import { FoiItem, FoiStage } from "../../domain/FoiItem";
import { List, ListItem, ListItemText, Popover } from "@material-ui/core";
import { AppBarButton } from "@ofqual/portal-components/components/SecondaryAppBar";
import { useDispatch } from "react-redux";
import { updateStage } from "../../redux/actions";

export type SelectStateProps = {
  foi: FoiItem;
};

export const SelectStateButton: React.FC<SelectStateProps> = (props) => {
  const dispatch = useDispatch();
  const [isShowingList, setIsShowingList] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const setStageFoi = (id: string, stage: string) =>
    dispatch(updateStage(id, stage));

  const handleSelectMenuOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
    setIsShowingList(true);
  };

  const handleSelectMenuClose = () => {
    setIsShowingList(false);
    setAnchorEl(null);
  };

  const handleSetStage = (stage: string) => {
    setStageFoi(props.foi.id, stage);
    handleSelectMenuClose();
  };

  return (
    <>
      <AppBarButton
        text="Set Stage"
        data-test="set-state-button"
        onClick={handleSelectMenuOpen}
      />

      {isShowingList ? (
        <Popover
          open={isShowingList}
          onClose={handleSelectMenuClose}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <List>
            {props.foi.status !== FoiStage["Stage 1"] && (
              <ListItem
                data-test="stage1-listItem"
                button
                onClick={() => {
                  handleSetStage("4");
                }}
              >
                <ListItemText primary="Stage 1" />
              </ListItem>
            )}
            {props.foi.status !== FoiStage["Stage 2"] && (
              <ListItem
                data-test="stage2-listItem"
                button
                onClick={() => {
                  handleSetStage("5");
                }}
              >
                <ListItemText primary="Stage 2" />
              </ListItem>
            )}
            {props.foi.status !== FoiStage["Stage 3"] && (
              <ListItem
                data-test="stage3-listItem"
                button
                onClick={() => {
                  handleSetStage("6");
                }}
              >
                <ListItemText primary="Stage 3" />
              </ListItem>
            )}
            {props.foi.status !== FoiStage["Clarification Sought"] && (
              <ListItem
                data-test="clarification-sought-listItem"
                button
                onClick={() => {
                  handleSetStage("7");
                }}
              >
                <ListItemText primary="Clarification sought" />
              </ListItem>
            )}
            <ListItem
              data-test="internal-review-listItem"
              button
              onClick={() => {
                handleSetStage("8");
              }}
            >
              <ListItemText primary="Internal Review" />
            </ListItem>
            <ListItem
              data-test="preliminary-ICO-listItem"
              button
              onClick={() => {
                handleSetStage("9");
              }}
            >
              <ListItemText primary="Preliminary ICO" />
            </ListItem>
            <ListItem
              data-test="ICO-listItem"
              button
              onClick={() => {
                handleSetStage("10");
              }}
            >
              <ListItemText primary="ICO" />
            </ListItem>
            <ListItem
              data-test="first-tier-tribunal-listItem"
              button
              onClick={() => {
                handleSetStage("11");
              }}
            >
              <ListItemText primary="First tier tribunal" />
            </ListItem>
            <ListItem
              data-test="upper-tier-tribunal-listItem"
              button
              onClick={() => {
                handleSetStage("12");
              }}
            >
              <ListItemText primary="Upper tier tribunal" />
            </ListItem>
            <ListItem
              data-test="appeal-listItem"
              button
              onClick={() => {
                handleSetStage("13");
              }}
            >
              <ListItemText primary="Appeal" />
            </ListItem>
          </List>
        </Popover>
      ) : null}
    </>
  );
};
